import { Suspense, lazy, useCallback } from "react";
import { useSelector } from "react-redux";

import { AsyncDataSuspense } from "@tsp-core/async/components/async-data-suspense";

import { accountsApi } from "@tsp-domains/accounts/api";
import { contractorsAccountsApi } from "@tsp-domains/contractor-accounts/api";
import { contractsApi } from "@tsp-domains/contracts/api";
import { partiesApi } from "@tsp-domains/parties/api";
import { paymentSystemApi } from "@tsp-domains/payment-system/api";
import { systemTypesApi } from "@tsp-domains/system-types/api";

import { Access } from "../../features/auth/components";
import { Layout } from "../../features/layout";
import { UserStateData, selectUserData } from "../../features/user";

const Content = lazy(() => import("./PayoutMethodsContent"));

const checkAccess = (user: UserStateData) => user.authenticated;

export function PayoutMethodsPage() {
  const data = useSelector(selectUserData);
  const getUserAccountsInfoQuery = accountsApi.useGetUserAccountsInfoQuery();
  const loadContractorsAccountsQuery = contractorsAccountsApi.useGetContractorsAccountsQuery();
  const getSystemTypesDictionaryQuery = systemTypesApi.useGetSystemTypesDictionaryQuery();
  const loadUserContractsQuery = contractsApi.useLoadUserContractsQuery();
  const getCountryCurrencyListQuery = paymentSystemApi.useGetCountryCurrencyListQuery();
  const [triggerGetPartyDetails, getPartyDetailsQuery] = partiesApi.useLazyGetPartyDetailsQuery();

  const onAccessHandler = useCallback(() => {
    triggerGetPartyDetails(data.party.uuid);
  }, [data, triggerGetPartyDetails]);

  return (
    <Access checkAccess={checkAccess} onAccess={onAccessHandler}>
      <Layout loading={false}>
        <AsyncDataSuspense
          queries={[
            getUserAccountsInfoQuery,
            loadContractorsAccountsQuery,
            getSystemTypesDictionaryQuery,
            loadUserContractsQuery,
            getCountryCurrencyListQuery,
            getPartyDetailsQuery,
          ]}
        >
          <Suspense fallback={null}>
            <Content />
          </Suspense>
        </AsyncDataSuspense>
      </Layout>
    </Access>
  );
}
